import { render } from "./leads-list.vue?vue&type=template&id=06485c38&scoped=true"
import script from "./leads-list.vue?vue&type=script&lang=js"
export * from "./leads-list.vue?vue&type=script&lang=js"

import "./leads-list.vue?vue&type=style&index=0&id=06485c38&lang=css"
import "./leads-list.vue?vue&type=style&index=1&id=06485c38&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06485c38"]])

export default __exports__